<template>
  <div class='apply-result-container'>
    <img alt="" src="@/assets/images/trialProductsList/goback.png" style="margin: 9px 0 0 8px;" width="19px" height="19px" @click.stop="goBack"/>
    <div  class="shopMess">
      <img :src="img" alt="" width="92" height="92" style="margin: 7px 0 7px 7px; border-radius: 8px; border: 1px solid #979797;">
      <div class="shopName">
        <p>{{ title }}</p>
        <span>x1</span>
      </div>
    </div>
    <div class="apply-container">
      <div class="apply">
        <van-field v-model="petitionReason" rows="1" autosize type="textarea" id="text-result" maxlength="100"
          placeholder="申请理由：填写申请理由，申请成功率更大哦～" />
        <!-- <textarea name=""  style="verticalAlign: top;" placeholder="最多填写100个字申请理由，可不填。"></textarea> -->
      </div>
    </div>
    <div class="apply-btn">
      <button @click="getPosition">免费申请</button>
    </div>
    <div id='container'></div>
  </div>
</template>

<script>
import API from '@/utils/axiosApi/zeroShoppingApi.js'
import wx from 'weixin-js-sdk'
import { is_weixin, getCookie, TestUserAgent, Debounce } from "@/assets/js/common.js";
import AMap from 'AMap';
import {freetrialClick} from '@/utils/freetrialClick.js'
export default {
  components: {},
  data() {
    return {
      petitionReason: "", //理由
      userAddress: "", //省份
      id: this.$route.query.id ? this.$route.query.id : 1,
      img: this.$route.query.img ? this.$route.query.img : '',
      title: this.$route.query.title ? this.$route.query.title : ''
    }
  },
  // 监听属性 类似于data概念
  computed: {},
  // 监控data中的数据变化
  watch: {},
  // 方法集合
  methods: {
    is_weixin,
    wxShare() {
      var that = this;
      if (that.is_weixin()) {
        that.$http.get(
          "/wechat/oauth2/getJSSDKConfig?url=" +
          encodeURIComponent(location.href.split("#")[0]),
          {},
          (res) => {
            wx.config({
              debug: false,
              appId: res.appId,
              timestamp: res.timestamp,
              nonceStr: res.nonceStr,
              signature: res.signature,
              openTagList: ["wx-open-launch-weapp"],
              jsApiList: [
                // "checkJsApi",
                // "onMenuShareTimeline", // 分享到朋友圈接口
                // "onMenuShareAppMessage", //  分享到朋友接口
                // "getLocation",
              ],

            });
            wx.ready(function () {
              // window.location.reload();
              if (TestUserAgent().isios && JSON.parse(localStorage.getItem("updatePage")) == 1) {
                window.location.reload();
                localStorage.removeItem('updatePage')
              }
            });
          }
        );
      }
    },
    getPosition() {
      freetrialClick({xmhh5_Freetrial_pageclick:"申请理由-免费申请"})
      freetrialClick({xmhh5_Freetrial_applyclick:"申请理由-免费申请"})
      var that = this;
      wx.getLocation({
        type: "wgs84", // 默认为wgs84的gps坐标，如果要返回直接给openLocation用的火星坐标，可传入'gcj02'
        success: function (res) {
          var latitude = res.latitude; // 纬度，浮点数，范围为90 ~ -90
          var longitude = res.longitude; // 经度，浮点数，范围为180 ~ -180。
          console.log("longitude==>", longitude, latitude);
          that.getLocation(latitude, longitude)  //获取用户位置接口
        },
        fail: function (err) {
          console.log(33333, err);
          that.sendApplyReson("")
        },
        cancel: function () {
          that.sendApplyReson("")
        },
      });
    },
    //用户理由接口
    sendApplyReson:Debounce(function(userAddress) {
      const userInfo = localStorage.getItem("userInfo") ? JSON.parse(localStorage.getItem("userInfo")) : {}
      const sendParams = {
        id: this.id,
        openId: getCookie("xmh_openid"),
        crmId: userInfo.crm_id,
        userName: getCookie("xmh_nickname"),
        phone: userInfo.mobile,
        userAddress,
        headUrl: getCookie("xmh_headimgurl"),
        petitionReason: this.petitionReason,
        userLevel: userInfo.level,
      }
      console.log(111114, sendParams)
      API.markApplyResult({}, sendParams, (res) => {
        if (res.code === 200) {
          // 成功 跳转至申请成功页
          // this.$router.go(-1)
          this.$router.push({path: "/trialSubSuccess", query: { img:this.img}});
        } else {
          // 失败
          this.$toast({
            message: res.message,
            duration: 2000,
          });
          if (res.code == 1001) {
            this.$router.go(-2)
          }
        }
      })
    }),
    // 获取定位
    getLocation(x, y) {
      console.log(AMap)
      var _this = this
      AMap.plugin('AMap.CitySearch', function () {
        var citySearch = new AMap.CitySearch()
        citySearch.getLocalCity(function (status, result) {
          if (status === 'complete' && result.info === 'OK') {
            // 查询成功，result即为当前所在城市信息
            console.log(result);
            var address = result.city;
            console.log(3336,address)
            _this.sendApplyReson(address)
          } else {
            console.log(3336,"error")
            _this.sendApplyReson("")
          }
        })
      })
    },
    goBack() {
      if (window.history.length > 1) {
        this.$router.back(-1);
      } else {
        this.$router.push({ path: "/trialProducts" });
      }
    },
  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created() { },
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    this.wxShare()
  },
}
</script>
<style lang='less' scoped>
// @import url(); 引入公共css类
.apply-result-container {
  width: 100%;
  height: 100vh;
  display: flex;
  flex-direction: column;
  background: #fff;
  .shopMess{
    height: 105px;
    width: 351px;
    margin: 8px 12px 0px;
    border-radius: 8px;
    display: flex;
    background: #F7F7F7;
    .shopName{
      position: relative;
      width: 223px;
      margin: 5px 7px 0 22px;
      p{
        font-size: 15px;
        font-family: PingFangSC-Medium, PingFang SC;
        color: #333333;
        line-height: 21px;
      }
      span{
        display: inline-block;
        position: absolute;
        right: 7px;
        top: 53px;
        color: #999999;
        font-size: 16px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        line-height: 22px;
      }
    }
  }
  .apply-container {
    padding: 12px 12px 14px;
    flex: 1;
    width: 351px;
    background: #FFFFFF;
  }

  .apply {
    width: 100%;
    height: 100%;
    border-radius: 8px;

    #text-result {
      width: 100%;
      height: 100%;
      border-style: none;
      font-size: 16px;
      text-align: left;
    }

    /deep/ .van-field__control::placeholder {
      font-size: 16px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #999999;
    }
  }

  .apply-btn {
    width: 100%;
    height: 65px;
    display: flex;
    align-items: center;
    justify-content: center;

    button {
      width: 351px;
      height: 45px;
      background: #FC656F;
      border-radius: 25px;
      border-style: none;
      font-size: 18px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #FFFFFF;
    }
  }
}

/deep/ .van-cell {
  height: 100%;
  border-radius: 8px;
  background: #f7f7f7;
}
</style>